import React from 'react'

export default function ServiceManagementPortal() {
  return (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M65.625 44.5312V14.0625C65.625 12.8193 65.1312 11.627 64.2522 10.7479C63.3731 9.86888 62.1806 9.375 60.9375 9.375H14.0625C12.8193 9.375 11.627 9.86888 10.7479 10.7479C9.86888 11.627 9.375 12.8193 9.375 14.0625V44.5312H65.625Z" stroke="url(#paint0_linear_4468_7145)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M72.2526 59.0344C72.5698 59.7481 72.7035 60.5297 72.6417 61.3081C72.5801 62.0869 72.3248 62.8375 71.8992 63.4922C71.4735 64.1472 70.8907 64.6853 70.2045 65.0575C69.5179 65.43 68.7495 65.625 67.9682 65.625H7.03088C6.24988 65.625 5.48126 65.43 4.79482 65.0575C4.10838 64.6853 3.52585 64.1472 3.1002 63.4922C2.67454 62.8375 2.41923 62.0869 2.35746 61.3081C2.29569 60.5297 2.42942 59.7481 2.7465 59.0344L9.37463 44.5312H65.6245L72.2526 59.0344Z" stroke="url(#paint1_linear_4468_7145)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32.8125 56.25H42.1875" stroke="url(#paint2_linear_4468_7145)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_4468_7145" x1="37.5" y1="9.375" x2="37.5" y2="44.5312" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint1_linear_4468_7145" x1="37.4996" y1="44.5312" x2="37.4996" y2="65.625" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint2_linear_4468_7145" x1="37.5" y1="56.25" x2="37.5" y2="57.25" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
      </defs>
    </svg>
  )
}
